import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { green } from '@mui/material/colors';

const useStyle = makeStyles(theme => ({
  container: {
    textTransform: 'none',
    fontWeight: 400,
    color: theme.palette.grey[500],
    borderColor: theme.palette.grey[500],
    borderRadius: 16,
    height: 32,
  },
  marginLeft: {
    marginLeft: theme.spacing(1),
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
  colorSuccess: {
    borderColor: green[600],
    color: green[600],
  },
}));

const RoundButton = ({ label, onClick, marginLeft, marginRight, color, ...props }) => {
  const classes = useStyle();

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={onClick}
      className={clsx(
        classes.container,
        marginLeft && classes.marginLeft,
        marginRight && classes.marginRight,
        color === 'success' && classes.colorSuccess,
      )}
      {...props}
    >
      {label}
    </Button>
  );
};

RoundButton.defaultProps = {
  marginLeft: false,
  marginRight: false,
  color: null,
  onClick: () => null,
};

RoundButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  marginLeft: PropTypes.bool,
  marginRight: PropTypes.bool,
  color: PropTypes.oneOf(['success', 'revert']),
};

export default RoundButton;
